import React, { Component } from 'react'
import { MuiGrid, MuiIconButton, MuiAddCircle, MuiTypography, MuiMoreVertIcon, MuiPersonAdd, MuiCancel, MuiDeleteIcon, MuiMenu, MuiEdit, MuiFab } from '../../ui/MaterialUIComponents';
import theme from '../../../assests/theme'
import moment from 'moment';
import { Link } from 'react-router-dom';
import routes from "../../navigation/Routes"
export class SchoolListComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      anchorEl: null,

    }
  }


  handleMenuClick = (event) => {

    this.setState({ anchorEl: event.currentTarget })
  }
  handleClose = () => {
    this.setState({ anchorEl: null })
  }



  onClickOfAddAdmin = () => {
    this.props.setActiveSchool(this.props.school);
    window.location.href = `/#${routes.createAdmin}`;
  }

  onClickOfDelete = () => {

    this.props.deleteSchool(this.props.school, this.props.index);
  }



  render() {
    let userProfile = this.props.userInformation.profiles[0].profileType
    let activeSchool = this.props.school;

    return (
      <MuiGrid conatiner xs={12} align="center" >
        <MuiGrid conatiner xs={8} style={theme.gridTableStyle} justify="center" alignItems="center">
          <MuiGrid container xs={12} direction='row' style={theme.gridHeaderStyle} alignContent="center">
            <MuiGrid item xs>
              <MuiGrid container direction="row">
                <MuiGrid item>
                  <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                    {this.props.school.name}
                  </MuiTypography>
                </MuiGrid>
                <MuiGrid item >
                  <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                    {" - " + this.props.school.address.line1}
                  </MuiTypography>
                </MuiGrid>

              </MuiGrid>
            </MuiGrid>

            <MuiGrid item xs={1}  >
              <Link to={{
                pathname: routes.editSchool,
                state: {
                  activeSchool: this.props.school

                },
                test: { test: "name" }
              }}>
                <MuiEdit color="primary" style={theme.pointer} />
              </Link>
            </MuiGrid>


            {userProfile == 'OWNER' && <MuiGrid item xs={1} >
              <MuiPersonAdd style={theme.pointer} color="primary" onClick={() => this.onClickOfAddAdmin()} />
            </MuiGrid>}

            {userProfile === "OWNER" && <MuiGrid item xs={1}>
              <MuiMoreVertIcon style={theme.pointer} color="primary" aria-owns={Boolean(this.state.anchorEl) ? 'menu-appbar' : undefined} aria-haspopup="true"
                onClick={this.handleMenuClick} />
              <MuiMenu
                id="menu-appbar"
                anchorEl={this.state.anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleClose}

              >
                <MuiIconButton onClick={() => this.onClickOfDelete()}>
                  <MuiDeleteIcon />
                </MuiIconButton>

              </MuiMenu>
            </MuiGrid>}

            <br />
          </MuiGrid>
          <br />

          <MuiGrid container xs={12} direction='row' >


            <MuiGrid container xs={2} alignContent="center">
              <MuiGrid item xs={1}>
              </MuiGrid>
            </MuiGrid>

            <MuiGrid container xs={10} >
              <MuiGrid item xs={3}   >
                <MuiGrid container direction="row">
                  <MuiGrid item>
                    <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                      Created on :
                      </MuiTypography>
                  </MuiGrid>
                  <MuiGrid item>
                    <MuiTypography >
                      {moment(this.props.school.createdDate).format("DD/MM/YYYY")}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
              </MuiGrid>
              <MuiGrid item xs={4}>
                <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                  Number of Teachers:
                      </MuiTypography>
              </MuiGrid>
              <MuiGrid item xs={3}>
                <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                  Number of Grades
                      </MuiTypography>
              </MuiGrid>
              <br />
              <br />
              <br />
              <MuiGrid item xs={3}>
                <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                  Edited on :{moment(this.props.school.lastModified).format("DD/MM/YYYY")}
                </MuiTypography>
              </MuiGrid>
              <MuiGrid item xs={4}>
                <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                  Number of Subjects:
                      </MuiTypography>
              </MuiGrid>
              <MuiGrid item xs={3}>
                <MuiTypography align="left" variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>
                  Number of Groups:
                      </MuiTypography>
              </MuiGrid>
              <br />
              <br />
              <br />
            </MuiGrid>
          </MuiGrid>
          <Link
            to={{
              pathname: routes.addNewRules,
              state: {
               // activeSchool: this.props.school

              }
            }}
          >
            <MuiGrid container justify="center" style={{ borderTop: "1px solid #4CADFE", padding: "4px" }}>
              <MuiGrid item  >
                <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
              </MuiGrid>

              <MuiGrid item xs={2} container alignItems="center" justify="center" >
                <MuiTypography
                  variant={theme.typographyStyles.BODY1}
                  color="primary"
                >
                  Add New Rules
								</MuiTypography>
              </MuiGrid>
            </MuiGrid>  </Link>
        </MuiGrid>

      </MuiGrid>
    )
  }
}

export default SchoolListComponent
